<template>
<div class="page-wrapper">
    <div class="container-fluid">
        <confirm title="Are you sure that you want to delete your account and erase all your data?" @confirm="reload" ref="confirm-delete-account"></confirm>

        <div class="page-body">
            <div class="container-sm">

                <div class="row row-cards">
                    <div class="col-lg-8 mx-auto">
                        <form class="card" @submit="update">
                            <div v-if="loading" class="position-relative">
                                <div class="progress progress-sm position-absolute w-100">
                                    <div class="progress-bar progress-bar-indeterminate"></div>
                                </div>
                            </div>
                            <div class="card-header">
                                <div class="form-label mb-0">Profile</div>
                            </div>
                            <div class="card-body">
                                <div class="mb-3 row">
                                    <label class="col-md-3 col-form-label">Email</label>
                                    <div class="col">
                                        <input type="text" class="form-control" placeholder="" v-model="email" disabled>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-md-3 col-form-label required">Name</label>
                                    <div class="col">
                                        <input type="text" class="form-control" placeholder="" required v-model="name">
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer d-flex">
                                <button type="button" class="btn-link text-danger" @click="deleteAccount">Delete Account</button>
                                <button type="submit" class="btn btn-primary ms-auto" :disabled="loading">Update Profile</button>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

</template>

<script>
// import api from "@/common/api";

import { mapState } from "vuex";

import Confirm from "@/components/Confirm.vue";

export default {
    computed: {
        ...mapState(["auth"])
    },

    components: {
        Confirm
    },
    data() {
        return {
            name: "",
            email: "",
            loading: false
        };
    },
    mounted() {
        this.load();
    },
    watch: {
        "auth.user"() {
            this.load();
        }
    },
    methods: {
        update() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            this.$store.dispatch("auth/update", { name: this.name }).then(() => {
                this.reload();
            }).catch(e => {
                this.flashError(e);
            }).finally(() => {
                this.loading = false;
            });
        },
        reload() {
            this.$store.dispatch("auth/info").then(() => {
            }).catch(e => {
                this.flashError(e);
            });
        },
        deleteAccount() {
            this.$refs["confirm-delete-account"].open(() => {
                this.loading = true;
                this.$store.dispatch("auth/delete").then(() => {
                    this.$router.push({ name: "login" });
                }).catch(e => {
                    this.flashError(e);
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
        load() {
            if (this.auth.user) {
                this.name = this.auth.user.name;
                this.email = this.auth.user.email;
            }
            /* api.stats().then(data => {
                console.log(data);

                const labels = [];
                const read = [];
                const generated = [];

                data.daily.forEach(i => {
                    labels.push(i.created);
                    read.push(parseInt(i.read_codes));
                    generated.push(parseInt(i.generated_codes));
                });

                console.log(labels);
                console.log(generated);
                console.log(read);
                this.chartData.labels = labels;
                this.chartData.datasets[0].data = generated;
                this.chartData.datasets[1].data = read;

                this.users = data.users;
                this.loaded = true;
            }).catch(e => {
                this.flashError(e);
            }); */
        }
    }
};
</script>
